import {
  Filter
} from '../common/filter';
import {
  TYPE_DIMENSIONS
} from './type-dimensions';
import {
  DEFAULT_STAT_LIMIT
} from '../common/config';

export class CurrentFilterService {
  constructor(
    PermissionService,
    FiltersService,
    CurrentModelService,
  ) {
    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.defaultDimension = window.defaultDimension ||
      'agent_account@user_name:user_name';
    this.filterBar = new Filter('Bar');
    this.filterBar.setDrilldown(this.defaultDimension);
    this.filter = null;

    this.PermissionService = PermissionService;

    this.timeFrom = new Date();
    this.timeTo = new Date(this.timeFrom.valueOf());
    this.timeFrom.setHours(0, 0, 0, 0);
    this.timeTo.setHours(23, 59, 59, 999);

    this.updatePanel();

    this.visibleDimensions = [];
  }

  createNewFilter(name, type) {

    const filterName = name ? name : type ? `${this.PermissionService.types[type].name} 1` : null;
    const filter = new Filter(filterName);
    this.setFilterName(filter);
    if (type) filter.content_type = type;
    return filter;
  }

  setFilterName(filter) {
    const setFilterName = () => {
      const parts = filter.name.split(' ');
      if (parts.length > 1) {
        let idx = '1';
        if (parseInt(parts[parts.length - 1], 10)) {
          idx = parseInt(parts[parts.length - 1], 10) + 1;
          parts.pop();
        }
        filter.name = parts.join(' ') + ' ' + idx;
      } else {
        filter.name = parts[0] + ' 1';
      }
    };
    while (this.FiltersService.find(f => (f.name === filter.name) && (f.id !== filter.id))) {
      setFilterName();
    }
    while (this.filter && this.filter.children && this.filter.children.find(f => (f.name === filter.name) && (f.id !== filter.id))) {
      setFilterName();
    }
  }

  newFilter(name, type) {
    this.filter = this.createNewFilter(name, type);
    if (type) {
      this.filter.content_type = type;
      if (this.filter.isDashboard || this.filter.isCard) this.filter.mode = type;
    }
  }

  rebuildVisibleDimensions() {
    let dims;
    if (this.filter && this.filter.filters && this.filter.filters.length > 0) {
      const selected = this.filter.filters.filter(f =>
          f['dimension'] === 'agent_eventtype@default:agent_eventtype' &&
          !f.predicates.filter(p => p === '!').length)
        .map(f => f['value']);
      dims = selected.map(key_selected => TYPE_DIMENSIONS[key_selected])
        .reduce((prev, curr) => {
          return prev.concat(curr ? curr.filter(dim => prev.indexOf(dim) === -1) : []);
        }, []);
    }
    if (dims && dims.length) {
      this.visibleDimensions = this.CurrentModelService.model.dimensions
        .filter(dim => dims.indexOf(dim['name']) !== -1);
    } else {
      this.visibleDimensions = this.CurrentModelService.model ?
        this.CurrentModelService.model.dimensions : [];
    }
  }

  get aggregateBarOrderName() {
    const dimension = this.CurrentModelService.model
      .getDimensionParts(this.filterBar.drilldown[0]);
    return `${dimension.dimension.name}.${dimension.level.label_attribute}`;
  }

  setOrderBar(dimension) {
    switch (this.filterBar.aggrOrder) {
      case 'nameAsc':
        this.filterBar.orderDir = 'asc';
        if (Filter.isTimeDimension(dimension)) {
          this.filterBar.order = Filter.orderForTimeDimension(dimension);
        } else this.filterBar.order = this.aggregateBarOrderName;
        break;
      case 'nameDesc':
        this.filterBar.orderDir = 'desc';
        if (Filter.isTimeDimension(dimension)) {
          this.filterBar.order = Filter.orderForTimeDimension(dimension);
        } else this.filterBar.order = this.aggregateBarOrderName;
        break;
      case 'statAsc':
        this.filterBar.order = 'record_count';
        this.filterBar.orderDir = 'asc';
        break;
      case 'statDesc':
        this.filterBar.order = 'record_count';
        this.filterBar.orderDir = 'desc';
        break;
      default:
        if (Filter.isTimeDimension(dimension)) {
          this.filterBar.orderDir = 'asc';
          this.filterBar.order = Filter.orderForTimeDimension(dimension);
        } else {
          this.filterBar.orderDir = 'desc';
          this.filterBar.order = 'record_count';
        }
    }


    this.filterBar.changed();
  }

  selectBarDim(dim) {
    this.filterBar.copyFrom(this.filter, true);
    this.filterBar.setDrilldown(dim.toString());
    this.setOrderBar(dim.toString());
    this.filterBar.setKeyword('');
    this.filterBar.page = 0;
    this.filterBar.lookup = null;
  }

  getReportQuery(filterBase) {
    const filter = new Filter('Report');
    const srcFilter = filterBase || this.filter;
    filter.copyFrom(srcFilter);
    filter.filters = srcFilter.filters.slice(0);
    filter.timeFrom = this.timeFrom;
    filter.timeTo = this.timeTo;
    filter.timePeriod = this.timePeriod;
    const obj = filter.buildQueryParams();

    if (this.filter.isCardOrDashboard) {
      obj.inDashboard = 1;
    }

    if (filter.isReports) {
      delete obj.order;
      delete obj.dir;
      if (filter.repOrderDirs) obj.repOrderDirs = filter.repOrderDirs;
      if (filter.repOrders) obj.repOrders = filter.repOrders;
    }
    obj['limit'] = srcFilter.customLimit ? srcFilter.customLimit : DEFAULT_STAT_LIMIT;

    const serialize = function(obj) {
      const str = [];
      for (const p in obj) {
        if (obj.hasOwnProperty(p)) {
          let v = obj[p];
          if (v instanceof Date) {
            v = v.toISOString();
          }
          if (v instanceof Array) {
            for (const idx in v) {
              str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v[idx]));
            }
          } else str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v));
        }
      }
      return str.join('&');
    };

    return serialize(obj);
  }

  getReportUrl(filter) {
    if (!filter || !filter.url) {
      return null;
    }
    const base = filter.url;
    if (base.indexOf('?') < 0) {
      return `${base}?${this.getReportQuery(filter)}`;
    } else {
      return `${base}&${this.getReportQuery(filter)}`;
    }
  }

  generateReport(url) {
    this.filter.setMode('reports');
    this.filter.url = url;
  }

  openFrame(url) {
    this.frameUrl = url;
  }

  reset() {
    this.frameUrl = null;
  }

  buildCardFilter() {
    if (this.filter.isDimensionCard) return;
    const criterion = this.filter.filters[0];

    if (!criterion || this.filter.filters.filter(f => f.dimension === criterion.dimension).length !== 1) {
      console.error('card filter should have at least one criterion');
      this.filter.children = [];
      return;
    }
    // let cardFilter = this.FiltersService.getCardFilter(criterion.dimension);
    this.filter.cardFilter = this.FiltersService.getCardFilter(criterion.dimension);
    if (this.filter.cardFilter) {
      // this.filter.children = angular.copy(this.filter.cardFilter.children);

      this.filter.children = this.filter.cardFilter.children
        .map(f => Object.assign(new Filter(), f, {
          filters: this.filter.filters.concat(f.filters)
        }));
      this.filter.name = this.filter.cardFilter.name;
    } else {
      this.filter.children = [];
    }
    const flt = this.FiltersService.findById(this.filter.id);
    this.filter.saved = flt ? !!this.filter.id && angular.equals(flt.filters, this.filter.filters) : !!this.filter.id;
  }

  getTimeFrom() {
    return Filter.dateToUrl(this.timeFrom);
  }

  getTimeTo() {
    return Filter.dateToUrl(this.timeTo);
  }

  updatePanel() {
    this.panel = this.PermissionService.filterConstructor ? 'constructor' : 'catalog';
    this.filterBar.skipStat = !this.PermissionService.aggregate_show_stat;
  }


}



// WEBPACK FOOTER //
// ./src/core/current-filter.service.js